export default __webpack_public_path__ + "static/media/dark_small.bd706cc2.png";